module.exports = __webpack_public_path__ + "media/opened.eaa24f4b.wav";